import {IconButton} from '@material-ui/core';
import React, {Component, useEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom';
import {rwbApi} from '../../../shared/apis/api';
import {reportAPI} from '../../../shared/apis/reportAPI';
import {errorAlert} from '../../../shared/utils/ErrorAlert';
import PostOptionIcon from '../components/svgs/PostOptionIcon';
import styles from './ReportAndDeleteOverlay.module.css';

const BlockAndReportOverlay = ({loggedInUser, profileId}) => {
  const [overlayVisible, setOverlayVisible] = useState(false);
  const myRef = useRef();
  const handleClickOutside = (event) => {
    if (myRef.current && !myRef.current.contains(event.target)) {
      setOverlayVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const blockUser = () => {
    if (window.confirm('Would you like to block this member?')) {
      setOverlayVisible(false);
      rwbApi
        .blockUser(profileId)
        .then(() => {
          errorAlert('This user has been blocked.');
        })
        .catch((err) => {
          console.warn(err);
          errorAlert('Could not block this user. Please try again.');
        });
    }
  };

  const reportUser = () => {
    if (window.confirm('Would you like to report this member?')) {
      setOverlayVisible(false);
      const reporterID = JSON.stringify({reporter: loggedInUser.id});
      reportAPI
        .user(profileId, reporterID)
        .then(() => {
          errorAlert('Your report has been sent.');
        })
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {});
    }
  };

  return (
    <div ref={myRef} style={{position: 'relative'}}>
      <div
        className={styles.optionsContainer}
        onClick={() => setOverlayVisible(true)}>
        <IconButton edge="start" color="inherit">
          <PostOptionIcon height="28" width="28" tintColor="var(--magenta)" />
        </IconButton>
      </div>
      {overlayVisible ? (
        <>
          <div
            style={{top: '38px', right: '25px'}}
            className={styles.container}>
            <button style={{color: 'black'}} onClick={() => blockUser()}>
              Block user
            </button>
            <button style={{color: 'black'}} onClick={() => reportUser()}>
              Report user
            </button>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default BlockAndReportOverlay;
